import {
  Airfryer,
  AntiInflamitory,
  BeansPlusLentils,
  Beef,
  Beets,
  BellPepper,
  Blender,
  Breakfast,
  Burger,
  CaffeineFree,
  Calendar as CalendarUtility,
  Calendar,
  CalorieConscious,
  Calories,
  ChefsPick,
  Chicken,
  Cilantro,
  Credit,
  Crockpot,
  Cuisines,
  Cyo,
  DairyFree,
  DairyFreeCheese,
  Dietary,
  Dislike,
  EggFree,
  Eggplant,
  Feeds1,
  Feeds2,
  Feeds3,
  Feeds4,
  Flavors,
  FreeShipping,
  FreshFish,
  Garlic,
  GarlicFree,
  Gift,
  GlutenFree,
  GlutenFreeBread,
  GrainFree,
  Grill,
  GutFriendly,
  GutHealth,
  HighFiber,
  HighProtein,
  IllustrationDietary,
  Immunity,
  KidsSnacks,
  Lamb,
  Lightbulb,
  LowCarb,
  LowCholesterol,
  LowFat,
  LowFodmap,
  LowSodium,
  LowSugar,
  Microwave,
  Mushrooms,
  NoBellPepper,
  NoCilantro,
  NoEggplant,
  NoMushrooms,
  None,
  NoOnion,
  NoPotatoes,
  NoTomatoes,
  Nutrition,
  Onion,
  OnionFree,
  OpenBox,
  Organic,
  Organic2,
  Oven,
  PeanutFree,
  Personalized,
  Pescatarian,
  PlantBased,
  PlantBasedEgg,
  Polarizing,
  Pork,
  Potatoes,
  Protein,
  Recent,
  Recipe,
  SesameFree,
  Shellfish,
  ShellfishFree,
  SmokedFish,
  Snacks,
  SnacksLarge,
  SnacksMedium,
  SnacksSmall,
  SoyFree,
  SpendMoreSaveMore,
  Spice,
  SpiceHot,
  SpiceMedium,
  SpiceMild,
  SpiceNone,
  Stove,
  StoveTop,
  Sweets,
  Sweets2,
  Sweets23,
  Sweets46,
  Sweets710,
  TableSetting,
  Tempeh,
  ThirtyOff,
  Tomatoes,
  TreeNutFree,
  Vegan,
  Vegetarian,
  WalletIllustrated,
  Coconut,
} from '../dist/illustrated';

import {
  Apple,
  ArrowLeft,
  ArrowRight,
  ArrowRightNew,
  Bookmark,
  Box,
  CalendarOutline,
  CaretDown,
  CaretDownNew,
  CaretLeft,
  CaretRight,
  CaretUp,
  Cart,
  Cart2,
  Chain,
  Check,
  CheckboxOff,
  CheckboxOn,
  Checklist,
  ChefHat,
  Clock as ClockIllustrated,
  Clock,
  Coin,
  Coin2,
  Facebook,
  FilterBadge,
  FilterBadgeActive,
  Fish,
  Flame,
  Fridge,
  Gear,
  Google,
  Heart,
  Home,
  HomeFilled,
  Information,
  Instagram,
  List,
  ListFilled,
  Lock,
  MagnifyingGlass,
  MagnifyingGlassFilled,
  Minus,
  Never,
  New as NewIllustrated,
  New,
  Pause,
  Pencil,
  Pepper,
  Pepper2,
  Person,
  PersonFilled,
  Platter,
  Play,
  Plus,
  PlusCircle,
  Question,
  RadioOff,
  RadioOn,
  Servings,
  Slider,
  Sparkle,
  StarFill,
  StarOutline,
  Sunrise,
  Swap,
  Tag,
  ThumbsDown,
  ThumbsDownFilled,
  ThumbsUp,
  ThumbsUpFilled,
  Trash,
  Trash2,
  Truck,
  Twitter,
  Vegan2,
  Vegetarian2,
  Wallet,
  Warning,
  X,
  XCircle,
  Youtube,
} from '../dist/utility';
import { IconVariant } from './IconVariant';

export interface IconProps {
  variant: IconVariant;
}

/**
 * @deprecated Import the Icon component itself from `@hungryroot/icons` instead.
 *             For example, just import `SnacksLarge` instead of using this component to render the SnacksLarge icon.
 */
export function Icon(props: IconProps) {
  const { variant } = props;
  switch (variant) {
    case IconVariant.SnacksLarge:
      return <SnacksLarge />;
    case IconVariant.SnacksMedium:
      return <SnacksMedium />;
    case IconVariant.SnacksSmall:
      return <SnacksSmall />;
    case IconVariant.Apple:
      return <Apple />;
    case IconVariant.ArrowLeft:
      return <ArrowLeft />;
    case IconVariant.ArrowRight:
      return <ArrowRight />;
    case IconVariant.ArrowRightNew:
      return <ArrowRightNew />;
    case IconVariant.Box:
      return <Box />;
    case IconVariant.CalendarUtility:
      return <CalendarUtility />;
    case IconVariant.CalendarOutline:
      return <CalendarOutline />;
    case IconVariant.CaretDown:
      return <CaretDown />;
    case IconVariant.CaretDownNew:
      return <CaretDownNew />;
    case IconVariant.CaretLeft:
      return <CaretLeft />;
    case IconVariant.CaretRight:
      return <CaretRight />;
    case IconVariant.CaretUp:
      return <CaretUp />;
    case IconVariant.Cart:
      return <Cart />;
    case IconVariant.Cart2:
      return <Cart2 />;
    case IconVariant.Chain:
      return <Chain />;
    case IconVariant.Check:
      return <Check />;
    case IconVariant.CheckboxOff:
      return <CheckboxOff />;
    case IconVariant.CheckboxOn:
      return <CheckboxOn />;
    case IconVariant.Checklist:
      return <Checklist />;
    case IconVariant.Clock:
      return <Clock />;
    case IconVariant.Coin:
      return <Coin />;
    case IconVariant.Coin2:
      return <Coin2 />;
    case IconVariant.Facebook:
      return <Facebook />;
    case IconVariant.FilterBadge:
      return <FilterBadge />;
    case IconVariant.FilterBadgeActive:
      return <FilterBadgeActive />;
    case IconVariant.Flame:
      return <Flame />;
    case IconVariant.Fridge:
      return <Fridge />;
    case IconVariant.Gear:
      return <Gear />;
    case IconVariant.Google:
      return <Google />;
    case IconVariant.Heart:
      return <Heart />;
    case IconVariant.Home:
      return <Home />;
    case IconVariant.HomeFilled:
      return <HomeFilled />;
    case IconVariant.Instagram:
      return <Instagram />;
    case IconVariant.List:
      return <List />;
    case IconVariant.ListFilled:
      return <ListFilled />;
    case IconVariant.Lock:
      return <Lock />;
    case IconVariant.MagnifyingGlass:
      return <MagnifyingGlass />;
    case IconVariant.MagnifyingGlassFilled:
      return <MagnifyingGlassFilled />;
    case IconVariant.Minus:
      return <Minus />;
    case IconVariant.Never:
      return <Never />;
    case IconVariant.New:
      return <New />;
    case IconVariant.Pause:
      return <Pause />;
    case IconVariant.Pencil:
      return <Pencil />;
    case IconVariant.Pepper:
      return <Pepper />;
    case IconVariant.Pepper2:
      return <Pepper2 />;
    case IconVariant.Person:
      return <Person />;
    case IconVariant.PersonFilled:
      return <PersonFilled />;
    case IconVariant.Platter:
      return <Platter />;
    case IconVariant.Play:
      return <Play />;
    case IconVariant.PlusCircle:
      return <PlusCircle />;
    case IconVariant.Plus:
      return <Plus />;
    case IconVariant.Question:
      return <Question />;
    case IconVariant.RadioOff:
      return <RadioOff />;
    case IconVariant.RadioOn:
      return <RadioOn />;
    case IconVariant.Servings:
      return <Servings />;
    case IconVariant.Slider:
      return <Slider />;
    case IconVariant.Sparkle:
      return <Sparkle />;
    case IconVariant.StarFill:
      return <StarFill />;
    case IconVariant.StarOutline:
      return <StarOutline />;
    case IconVariant.Sunrise:
      return <Sunrise />;
    case IconVariant.Swap:
      return <Swap />;
    case IconVariant.Tag:
      return <Tag />;
    case IconVariant.Trash:
      return <Trash />;
    case IconVariant.Trash2:
      return <Trash2 />;
    case IconVariant.Twitter:
      return <Twitter />;
    case IconVariant.X:
      return <X />;
    case IconVariant.YouTube:
      return <Youtube />;
    case IconVariant.ThumbsDown:
      return <ThumbsDown />;
    case IconVariant.ThumbsDownFilled:
      return <ThumbsDownFilled />;
    case IconVariant.ThumbsUp:
      return <ThumbsUp />;
    case IconVariant.ThumbsUpFilled:
      return <ThumbsUpFilled />;
    case IconVariant.Truck:
      return <Truck />;
    case IconVariant.Bookmark:
      return <Bookmark />;
    case IconVariant.Wallet:
      return <Wallet />;
    case IconVariant.Information:
      return <Information />;
    case IconVariant.ChefHat:
      return <ChefHat />;
    case IconVariant.Fish:
      return <Fish />;
    case IconVariant.Vegetarian2:
      return <Vegetarian2 />;
    case IconVariant.Vegan2:
      return <Vegan2 />;

    // illustrated
    case IconVariant.Airfryer:
      return <Airfryer />;
    case IconVariant.AntiInflamitory:
      return <AntiInflamitory />;
    case IconVariant.BeansPlusLentils:
      return <BeansPlusLentils />;
    case IconVariant.Beef:
      return <Beef />;
    case IconVariant.Beets:
      return <Beets />;
    case IconVariant.BellPepper:
      return <BellPepper />;
    case IconVariant.NoBellPepper:
      return <NoBellPepper />;
    case IconVariant.Blender:
      return <Blender />;
    case IconVariant.Breakfast:
      return <Breakfast />;
    case IconVariant.Burger:
      return <Burger />;
    case IconVariant.Calendar:
      return <Calendar />;
    case IconVariant.Calories:
      return <Calories />;
    case IconVariant.CalorieConscious:
      return <CalorieConscious />;
    case IconVariant.ChefsPick:
      return <ChefsPick />;
    case IconVariant.Chicken:
      return <Chicken />;
    case IconVariant.Cilantro:
      return <Cilantro />;
    case IconVariant.NoCilantro:
      return <NoCilantro />;
    case IconVariant.ClockIllustrated:
      return <ClockIllustrated />;
    case IconVariant.Coconut:
      return <Coconut />;
    case IconVariant.Credit:
      return <Credit />;
    case IconVariant.Crockpot:
      return <Crockpot />;
    case IconVariant.Cuisines:
      return <Cuisines />;
    case IconVariant.CYO:
      return <Cyo />;
    case IconVariant.DairyFree:
      return <DairyFree />;
    case IconVariant.DairyFreeCheese:
      return <DairyFreeCheese />;
    case IconVariant.Dietary:
      return <Dietary />;
    case IconVariant.Dislike:
      return <Dislike />;
    case IconVariant.EggFree:
      return <EggFree />;
    case IconVariant.Eggplant:
      return <Eggplant />;
    case IconVariant.NoEggplant:
      return <NoEggplant />;
    case IconVariant.FreshFish:
      return <FreshFish />;
    case IconVariant.Garlic:
      return <Garlic />;
    case IconVariant.Gift:
      return <Gift />;
    case IconVariant.GlutenFree:
      return <GlutenFree />;
    case IconVariant.GlutenFreeBread:
      return <GlutenFreeBread />;
    case IconVariant.Grill:
      return <Grill />;
    case IconVariant.GutFriendly:
      return <GutFriendly />;
    case IconVariant.GutHealth:
      return <GutHealth />;
    case IconVariant.HighFiber:
      return <HighFiber />;
    case IconVariant.HighProtein:
      return <HighProtein />;
    case IconVariant.Immunity:
      return <Immunity />;
    case IconVariant.IllustrationDietary:
      return <IllustrationDietary />;
    case IconVariant.Lamb:
      return <Lamb />;
    case IconVariant.LowFat:
      return <LowFat />;
    case IconVariant.LowCholesterol:
      return <LowCholesterol />;
    case IconVariant.LowFodmap:
      return <LowFodmap />;
    case IconVariant.Microwave:
      return <Microwave />;
    case IconVariant.Mushrooms:
      return <Mushrooms />;
    case IconVariant.NoMushrooms:
      return <NoMushrooms />;
    case IconVariant.NewIllustrated:
      return <NewIllustrated />;
    case IconVariant.Nutrition:
      return <Nutrition />;
    case IconVariant.Onion:
      return <Onion />;
    case IconVariant.NoOnion:
      return <NoOnion />;
    case IconVariant.Organic:
      return <Organic />;
    case IconVariant.Organic2:
      return <Organic2 />;
    case IconVariant.PeanutFree:
      return <PeanutFree />;
    case IconVariant.Personalized:
      return <Personalized />;
    case IconVariant.Pescatarian:
      return <Pescatarian />;
    case IconVariant.PlantBased:
      return <PlantBased />;
    case IconVariant.PlantBasedEgg:
      return <PlantBasedEgg />;
    case IconVariant.Polarizing:
      return <Polarizing />;
    case IconVariant.Pork:
      return <Pork />;
    case IconVariant.Potatoes:
      return <Potatoes />;
    case IconVariant.NoPotatoes:
      return <NoPotatoes />;
    case IconVariant.Protein:
      return <Protein />;
    case IconVariant.Recent:
      return <Recent />;
    case IconVariant.Recipe:
      return <Recipe />;
    case IconVariant.Shellfish:
      return <Shellfish />;
    case IconVariant.ShellfishFree:
      return <ShellfishFree />;
    case IconVariant.SmokedFish:
      return <SmokedFish />;
    case IconVariant.SoyFree:
      return <SoyFree />;
    case IconVariant.Spice:
      return <Spice />;
    case IconVariant.SpiceHot:
      return <SpiceHot />;
    case IconVariant.SpiceMedium:
      return <SpiceMedium />;
    case IconVariant.SpiceMild:
      return <SpiceMild />;
    case IconVariant.SpiceNone:
      return <SpiceNone />;
    case IconVariant.Stove:
      return <Stove />;
    case IconVariant.Tempeh:
      return <Tempeh />;
    case IconVariant.Tomatoes:
      return <Tomatoes />;
    case IconVariant.NoTomatoes:
      return <NoTomatoes />;
    case IconVariant.TreeNutFree:
      return <TreeNutFree />;
    case IconVariant.Vegan:
      return <Vegan />;
    case IconVariant.Vegetarian:
      return <Vegetarian />;
    case IconVariant.KidsSnacks:
      return <KidsSnacks />;

    case IconVariant.Feeds1:
      return <Feeds1 />;
    case IconVariant.Feeds2:
      return <Feeds2 />;
    case IconVariant.Feeds3:
      return <Feeds3 />;
    case IconVariant.Feeds4:
      return <Feeds4 />;
    case IconVariant.StoveTop:
      return <StoveTop />;
    case IconVariant.Oven:
      return <Oven />;

    case IconVariant.Flavors:
      return <Flavors />;
    case IconVariant.FreeShipping:
      return <FreeShipping />;
    case IconVariant.SpendMoreSaveMore:
      return <SpendMoreSaveMore />;
    case IconVariant.ThirtyOff:
      return <ThirtyOff />;
    case IconVariant.OpenBox:
      return <OpenBox />;
    case IconVariant.Sweets:
      return <Sweets />;
    case IconVariant.Sweets2:
      return <Sweets2 />;
    case IconVariant.Snacks:
      return <Snacks />;
    case IconVariant.TableSetting:
      return <TableSetting />;
    case IconVariant.WalletIllustrated:
      return <WalletIllustrated />;
    case IconVariant.Lightbulb:
      return <Lightbulb />;
    case IconVariant.LowCarb:
      return <LowCarb />;
    case IconVariant.LowSodium:
      return <LowSodium />;
    case IconVariant.LowSugar:
      return <LowSugar />;
    case IconVariant.XCircle:
      return <XCircle />;
    case IconVariant.Warning:
      return <Warning />;

    case IconVariant.None:
      return <None />;
    case IconVariant.Sweets23:
      return <Sweets23 />;
    case IconVariant.Sweets46:
      return <Sweets46 />;
    case IconVariant.Sweets710:
      return <Sweets710 />;

    case IconVariant.SesameFree:
      return <SesameFree />;
    case IconVariant.GrainFree:
      return <GrainFree />;
    case IconVariant.GarlicFree:
      return <GarlicFree />;
    case IconVariant.OnionFree:
      return <OnionFree />;
    case IconVariant.CaffeineFree:
      return <CaffeineFree />;
  }
}
